import { configure, defineRule } from 'vee-validate'
import { required, email, min } from '@vee-validate/rules'
import { localize } from '@vee-validate/i18n'

import da from '@vee-validate/i18n/dist/locale/da.json'
import no from '@vee-validate/i18n/dist/locale/nn_NO.json'

localize('da', da)

defineRule('required', required)
defineRule('email', email)
defineRule('min', min)

configure({
  generateMessage: localize({
    da,
    no
  })
})

export default defineNuxtPlugin(() => {})
